import { SYS_SPACE_RELATIVE_XS } from '@oneaudi/unified-web-alpha-common';
import { TextLink } from '@oneaudi/unified-web-alpha-components';
import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { useI18n } from '~/app/i18n/i18n';
import { CompareLayerWrapper } from '~/app/pages/configurator/components/compare-layer-wrapper';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { EventAction, LayerType } from '~/app/tracking/feld-m-types';
import { Dialog } from '~/components/dialog';

export const TrimLineCompare = () => {
	const { i18n } = useI18n();

	const [isOpen, setIsOpen] = useState<boolean>(false);

	const onOpenChange = useCallback(
		(open: boolean) => {
			setIsOpen(open);
			appTrackingService.trackSelectionClickEvent({
				eventAction: EventAction.InternalLink,
				eventName: `click to ${open ? 'open' : 'close'} ${LayerType.EngineAndTrimComparisonLayer}`,
				label: i18n('ngc.dialogs.comparison.trimline.trigger'),
				elementName: 'text link',
			});

			appTrackingService.updateLayerComponent(LayerType.EngineAndTrimComparisonLayer, open ? 'open' : 'close');

			appTrackingService.viewChangeEvent({
				eventName: open ? `configurator - ${LayerType.EngineAndTrimComparisonLayer}` : 'generic',
				componentName: open ? `${LayerType.EngineAndTrimComparisonLayer.split(' ').join('-')}` : '',
			});
		},
		[i18n],
	);

	return (
		<CompareLinkStyle>
			<Dialog
				classNameDialog="drive-train-compare-dialog"
				triggerElement={
					<TextLink variant={'standalone'} size={'sm'} onClick={() => onOpenChange(true)}>
						{i18n('ngc.dialogs.comparison.trimline.trigger')}
					</TextLink>
				}
				onCloseButtonClick={() => onOpenChange(false)}
				open={isOpen}>
				{isOpen && (
					<CompareLayerWrapper
						open={isOpen}
						key="drive-train-compare"
						setIsOpen={onOpenChange}
						config={{
							selectedTab: 'standardEquipment',
							isCompareActive: true,
						}}
					/>
				)}
			</Dialog>
		</CompareLinkStyle>
	);
};

export const CompareLinkStyle = styled.div`
	margin-top: ${SYS_SPACE_RELATIVE_XS};
`;
